import * as React from 'react'
import { IconPlus } from '@tabler/icons-react'
import { cn } from '@/lib/utils'

export interface BlueButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text: string
  direction?: 'right' | 'left' | 'up' | 'down'
  fullWidth?: boolean
}

export const BlueButton: React.FC<BlueButtonProps> = ({
  text,
  className,
  fullWidth,
  type = 'button',
  ...rest
}) => {
  return (
    <button
      type={type}
      className={cn(
        'box-border inline-flex h-9 w-[148px] items-center justify-center gap-2 rounded-lg bg-[#0057B8] px-4 text-sm font-medium text-white transition-colors select-none',
        'shadow-[inset_0_-2px_0_rgba(10,13,18,0.05)]',
        'hover:bg-[#0050AB] focus-visible:ring-2 focus-visible:ring-white/40 focus-visible:outline-none active:bg-[#004997]',
        fullWidth && 'w-full',
        className
      )}
      {...rest}
    >
      <IconPlus className='size-4' aria-hidden='true' />
      <span>{text}</span>
    </button>
  )
}

export default BlueButton
